import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import { PartnerProvider } from "./contexts/PartnerContext";
import { NotificationProvider } from "./contexts/NotificationContext";

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <PartnerProvider>
          <NotificationProvider>
            <Routes />
          </NotificationProvider>
        </PartnerProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
